export class PackageUnitConverter {
	public static readonly selector = '.js-package-unit-converter'

	private static readonly locale = document.documentElement.lang || 'en'

	private readonly element: HTMLElement
	private inputs: HTMLInputElement[] = []
	private packagesElement: HTMLElement
	private unitsElement: HTMLElement

	public constructor(element: HTMLElement) {
		this.element = element

		const inputs = this.element.querySelectorAll<HTMLInputElement>(`${PackageUnitConverter.selector}__input`)
		const packagesElement = this.element.querySelector<HTMLElement>(`${PackageUnitConverter.selector}__packages`)
		const unitsElement = this.element.querySelector<HTMLElement>(`${PackageUnitConverter.selector}__units`)

		if (!inputs || !packagesElement || !unitsElement) {
			throw new Error('PackageUnitConverter: Missing required elements.')
		}

		this.inputs = Array.from(inputs)
		this.packagesElement = packagesElement
		this.unitsElement = unitsElement

		this.inputs.forEach((input) => input.addEventListener('change', this.handleInputChange.bind(this)))
	}

	private handleInputChange(): void {
		const packages = this.getPackages()
		const units = this.getUnits()

		this.updatePackages(packages)
		this.updateUnits(units)
	}

	private updatePackages(packages: number): void {
		this.packagesElement.textContent = packages.toLocaleString(PackageUnitConverter.locale)
	}

	private updateUnits(units: number): void {
		this.unitsElement.textContent = units.toLocaleString(PackageUnitConverter.locale)
	}

	private getPackages(): number {
		let packages = 0

		this.inputs.forEach((input) => {
			packages += input.valueAsNumber
		})

		return packages
	}

	private getUnits(): number {
		let units = 0

		this.inputs.forEach((input) => {
			units += input.valueAsNumber * parseFloat(input.dataset.unitPerPackage || '0')
		})

		return units
	}
}
